import React, { useMemo } from 'react';
import { Image } from '@hz-design-system/web-ui';
import { TMpCard } from 'types/TMpCard';
import Classes from './MpCard.scss';
import { trackGAEvent } from '../../../../utils/gaTracking';

const MpCardBanner = ({ mpCards }: { mpCards: TMpCard[] }) => {
  const mpCardBanner = useMemo(() => {
    if (!mpCards?.length) return null;
    return mpCards.find((card) => card.id === 'mp-cards-homepage-top-banner') || null;
  }, [mpCards]);

  if (!mpCardBanner) return null;

  const clickHandler = () => {
    if (mpCardBanner.trackingEventName) {
      trackGAEvent(mpCardBanner.trackingEventName, 'HPCards');
    }
    if (mpCardBanner.landingUrl) {
      window.location.href = mpCardBanner.landingUrl;
    }
  };

  return (
    <div
      className={Classes.mpCardBanner}
      onClick={clickHandler}
      onKeyDown={(e) => e.key === 'Enter' && clickHandler()}
      role="button"
      tabIndex={0}
    >
      <Image src={mpCardBanner.imageUrl} alt="Marktplaats Marketing Banner" loading="eager" decoding="sync" />
    </div>
  );
};

export default React.memo(MpCardBanner);
